module.exports = __webpack_public_path__ + "img/emoji_95.4e87d238.png";